<template>
  <div style="padding: 20px 20px 20px 0">
    <el-button @click="goBack" type="primary">返回</el-button>
    <div class="info">基本信息</div>
    <div class="infos">
      <div style="display: flex; justify-content: space-between; padding: 10px">
        <div class="infoDetail">
          <div>卡号:{{ form.cardNo }}</div>
          <div>姓名:{{ form.name }}</div>
          <div>性别:</div>
          <div>身份证号:{{ form.idCard }}</div>
          <div>手机号:{{ form.phone }}</div>
          <div>所属单位:{{ form.company }}</div>
          <div>身份:{{ form.cardNo }}</div>
          <div>绑定银行卡号:{{ form.bankNum }}</div>
        </div>
        <div>
          <h3>人脸照片</h3>
          <div></div>
        </div>
      </div>
      <div class="infoDetail" style="padding: 10px">
        <h3>权限范围</h3>
        <div>{{ form.purview }}</div>
      </div>
      <div style="display: flex; justify-content: space-between; padding: 10px">
        <div class="infoDetail">
          <h3>账户信息</h3>
          <div>卡号:{{ form.cardNo }}</div>
          <div>付款二维码</div>
        </div>
        <div>余额</div>
      </div>
    </div>
    <div style="display: flex; align-items: center">
      <div style="width: 70px">二维码：</div>
      <img
        v-if="form.cardNo"
        :src="form.base64"
        style="width: 150px; height: 150px"
      />
      <img v-else style="width: 150px; height: 150px" />
    </div>
    <div style="display: flex; align-items: center; margin-top: 20px">
      <div style="display: flex; align-items: center">
        <div style="width: 70px">公寓卡：</div>
        <img
          :src="require('../../assets/imgs/bg.jpg')"
          style="width: 300px; height: 170px"
        />
      </div>

      <div style="position: relative; top: 0; left: -290px; width: 100%; font-size: 14px">
        <div style="margin-top: -10px">卡号：{{ form.cardNo }}</div>
        <div style="margin-top: 30px">姓名：{{ form.name }}</div>
        <div style="margin-top: 30px">身份证号：{{ form.idCard }}</div>
      </div>
    </div>

    <div class="info">账单信息</div>
    <el-form :model="selectForm" :inline="true">
      <el-form-item label="记录类型">
        <el-select v-model="selectForm.recordType">
          <el-option value="recordOfConsume" label="账户记录"></el-option>
          <el-option value="recordOfMenJin" label="门禁记录"></el-option>
          <el-option value="recordOfParking" label="停车记录"></el-option>
          <el-option value="recordOfLibraryBrowsing" label="图书阅览室记录"></el-option>
          <el-option value="recordOfExercise" label="健身房记录"></el-option>
          <el-option value="recordOfVisit" label="来访记录"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <el-table
      v-if="
        selectForm.recordType == 'recordOfMenJin' ||
        selectForm.recordType == 'recordOfLibraryBrowsing' ||
        selectForm.recordType == 'recordOfExercise'
      "
      :data="tableData"
    >
      <el-table-column prop="" label="序号"></el-table-column>
      <el-table-column label="刷卡时间"></el-table-column>
      <el-table-column label="刷卡地点"></el-table-column>
      <el-table-column label="进出类别(进门/出门)"></el-table-column>
      <el-table-column
        v-if="selectForm.recordType == 'recordOfMenJin'"
        label="开门状态"
      ></el-table-column>
      <el-table-column
        v-if="selectForm.recordType != 'recordOfMenJin'"
        label="刷卡地点"
      ></el-table-column>
    </el-table>
    <el-table v-if="selectForm.recordType == 'recordOfConsume'" :data="tableData">
      <el-table-column prop="id" label="序号"></el-table-column>
      <el-table-column prop="orderNum" label="交易流水号"></el-table-column>
      <el-table-column prop="totalPrice" label="交易金额"></el-table-column>
      <el-table-column prop="payTime" label="交易时间">
        <template slot-scope="{ row }">
          {{ setTime(row.payTime) }}
        </template>
      </el-table-column>
      <el-table-column prop="payPurpose" label="交易方式"></el-table-column>
      <el-table-column prop="userName" label="交易人"></el-table-column>
      <el-table-column prop="orderDescribe" label="备注说明"></el-table-column>
    </el-table>
    <el-table v-if="selectForm.recordType == 'recordOfParking'" :data="tableData">
      <el-table-column prop="carNum" label="车牌号"></el-table-column>
      <el-table-column prop="parkingLot" label="停车场"></el-table-column>
      <el-table-column prop="startTime" label="进场时间">
        <template slot-scope="{ row }">
          {{ setTime(row.startTime) }}
        </template>
      </el-table-column>
      <el-table-column prop="endTime" label="出场时间">
        <template slot-scope="{ row }">
          {{ setTime(row.endTime) }}
        </template>
      </el-table-column>
      <el-table-column prop="elapsedTime" label="停车时长(分钟)"> </el-table-column>
      <el-table-column prop="amount" label="停车费"></el-table-column>
    </el-table>
    <el-table v-if="selectForm.recordType == 'recordOfVisit'" :data="tableData">
      <el-table-column prop="cardNo" label="一卡通号"></el-table-column>
      <el-table-column prop="visitor" label="来访人"></el-table-column>
      <el-table-column prop="phone" label="手机号"></el-table-column>
      <el-table-column prop="idCard" label="身份证号"></el-table-column>
      <el-table-column prop="sex" label="性别"></el-table-column>
      <el-table-column prop="visitingTime" label="来访时间">
        <template slot-scope="{ row }">
          {{ setTime(row.visitingTime) }}
        </template>
      </el-table-column>
      <el-table-column prop="reason" label="访问缘由"></el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectForm: {
        recordType: "",
        userId: null,
        currentPage: "1",
        oneCardNum: "",
        pageSize: "10",
      },
      form: {},
      tableData: [],
    };
  },
  watch: {
    "selectForm.recordType": function (val) {
      console.log(val);
      this.$http
        .post("/api/oneCard/queryBatch", {
          ...this.selectForm,
        })
        .then((res) => {
          if (this.selectForm.recordType != "recordOfParking") {
            this.tableData = res.data.data.items;
          } else {
            this.tableData = res.data.data.page.items;
          }

          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  },
  mounted() {
    this.form = this.$route.params.val;
    this.selectForm.userId = this.form.userId;
    this.selectForm.oneCardNum = this.form.cardNo;
    console.log(this.$route.params.val);
  },
};
</script>

<style scoped="scoped">
.info {
  background-color: #00bfaf;
  padding: 10px;
  margin: 10px 0;
  color: white;
}

.infos {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.infos > div {
  width: 30%;
  font-size: 14px;
}

.infoDetail > div {
  margin-bottom: 10px;
}
</style>
